/*
 * Key Code values
 * @deprecated - use individual keycode exports
 */
export var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["alt"] = 18] = "alt";
    KeyCodes[KeyCodes["arrowDown"] = 40] = "arrowDown";
    KeyCodes[KeyCodes["arrowLeft"] = 37] = "arrowLeft";
    KeyCodes[KeyCodes["arrowRight"] = 39] = "arrowRight";
    KeyCodes[KeyCodes["arrowUp"] = 38] = "arrowUp";
    KeyCodes[KeyCodes["back"] = 8] = "back";
    KeyCodes[KeyCodes["backSlash"] = 220] = "backSlash";
    KeyCodes[KeyCodes["break"] = 19] = "break";
    KeyCodes[KeyCodes["capsLock"] = 20] = "capsLock";
    KeyCodes[KeyCodes["closeBracket"] = 221] = "closeBracket";
    KeyCodes[KeyCodes["colon"] = 186] = "colon";
    KeyCodes[KeyCodes["colon2"] = 59] = "colon2";
    KeyCodes[KeyCodes["comma"] = 188] = "comma";
    KeyCodes[KeyCodes["ctrl"] = 17] = "ctrl";
    KeyCodes[KeyCodes["delete"] = 46] = "delete";
    KeyCodes[KeyCodes["end"] = 35] = "end";
    KeyCodes[KeyCodes["enter"] = 13] = "enter";
    KeyCodes[KeyCodes["equals"] = 187] = "equals";
    KeyCodes[KeyCodes["equals2"] = 61] = "equals2";
    KeyCodes[KeyCodes["equals3"] = 107] = "equals3";
    KeyCodes[KeyCodes["escape"] = 27] = "escape";
    KeyCodes[KeyCodes["forwardSlash"] = 191] = "forwardSlash";
    KeyCodes[KeyCodes["function1"] = 112] = "function1";
    KeyCodes[KeyCodes["function10"] = 121] = "function10";
    KeyCodes[KeyCodes["function11"] = 122] = "function11";
    KeyCodes[KeyCodes["function12"] = 123] = "function12";
    KeyCodes[KeyCodes["function2"] = 113] = "function2";
    KeyCodes[KeyCodes["function3"] = 114] = "function3";
    KeyCodes[KeyCodes["function4"] = 115] = "function4";
    KeyCodes[KeyCodes["function5"] = 116] = "function5";
    KeyCodes[KeyCodes["function6"] = 117] = "function6";
    KeyCodes[KeyCodes["function7"] = 118] = "function7";
    KeyCodes[KeyCodes["function8"] = 119] = "function8";
    KeyCodes[KeyCodes["function9"] = 120] = "function9";
    KeyCodes[KeyCodes["home"] = 36] = "home";
    KeyCodes[KeyCodes["insert"] = 45] = "insert";
    KeyCodes[KeyCodes["menu"] = 93] = "menu";
    KeyCodes[KeyCodes["minus"] = 189] = "minus";
    KeyCodes[KeyCodes["minus2"] = 109] = "minus2";
    KeyCodes[KeyCodes["numLock"] = 144] = "numLock";
    KeyCodes[KeyCodes["numPad0"] = 96] = "numPad0";
    KeyCodes[KeyCodes["numPad1"] = 97] = "numPad1";
    KeyCodes[KeyCodes["numPad2"] = 98] = "numPad2";
    KeyCodes[KeyCodes["numPad3"] = 99] = "numPad3";
    KeyCodes[KeyCodes["numPad4"] = 100] = "numPad4";
    KeyCodes[KeyCodes["numPad5"] = 101] = "numPad5";
    KeyCodes[KeyCodes["numPad6"] = 102] = "numPad6";
    KeyCodes[KeyCodes["numPad7"] = 103] = "numPad7";
    KeyCodes[KeyCodes["numPad8"] = 104] = "numPad8";
    KeyCodes[KeyCodes["numPad9"] = 105] = "numPad9";
    KeyCodes[KeyCodes["numPadDivide"] = 111] = "numPadDivide";
    KeyCodes[KeyCodes["numPadDot"] = 110] = "numPadDot";
    KeyCodes[KeyCodes["numPadMinus"] = 109] = "numPadMinus";
    KeyCodes[KeyCodes["numPadMultiply"] = 106] = "numPadMultiply";
    KeyCodes[KeyCodes["numPadPlus"] = 107] = "numPadPlus";
    KeyCodes[KeyCodes["openBracket"] = 219] = "openBracket";
    KeyCodes[KeyCodes["pageDown"] = 34] = "pageDown";
    KeyCodes[KeyCodes["pageUp"] = 33] = "pageUp";
    KeyCodes[KeyCodes["period"] = 190] = "period";
    KeyCodes[KeyCodes["print"] = 44] = "print";
    KeyCodes[KeyCodes["quote"] = 222] = "quote";
    KeyCodes[KeyCodes["scrollLock"] = 145] = "scrollLock";
    KeyCodes[KeyCodes["shift"] = 16] = "shift";
    KeyCodes[KeyCodes["space"] = 32] = "space";
    KeyCodes[KeyCodes["tab"] = 9] = "tab";
    KeyCodes[KeyCodes["tilde"] = 192] = "tilde";
    KeyCodes[KeyCodes["windowsLeft"] = 91] = "windowsLeft";
    KeyCodes[KeyCodes["windowsOpera"] = 219] = "windowsOpera";
    KeyCodes[KeyCodes["windowsRight"] = 92] = "windowsRight";
})(KeyCodes || (KeyCodes = {}));
export const keyCodeAlt = 18;
export const keyCodeArrowDown = 40;
export const keyCodeArrowLeft = 37;
export const keyCodeArrowRight = 39;
export const keyCodeArrowUp = 38;
export const keyCodeBack = 8;
export const keyCodeBackSlash = 220;
export const keyCodeBreak = 19;
export const keyCodeCapsLock = 20;
export const keyCodeCloseBracket = 221;
export const keyCodeColon = 186;
export const keyCodeColon2 = 59; // Opera and Firefox
export const keyCodeComma = 188;
export const keyCodeCtrl = 17;
export const keyCodeDelete = 46;
export const keyCodeEnd = 35;
export const keyCodeEnter = 13;
export const keyCodeEquals = 187;
export const keyCodeEquals2 = 61; // Opera
export const keyCodeEquals3 = 107; // Firefox
export const keyCodeEscape = 27;
export const keyCodeForwardSlash = 191;
export const keyCodeFunction1 = 112;
export const keyCodeFunction10 = 121;
export const keyCodeFunction11 = 122;
export const keyCodeFunction12 = 123;
export const keyCodeFunction2 = 113;
export const keyCodeFunction3 = 114;
export const keyCodeFunction4 = 115;
export const keyCodeFunction5 = 116;
export const keyCodeFunction6 = 117;
export const keyCodeFunction7 = 118;
export const keyCodeFunction8 = 119;
export const keyCodeFunction9 = 120;
export const keyCodeHome = 36;
export const keyCodeInsert = 45;
export const keyCodeMenu = 93;
export const keyCodeMinus = 189;
export const keyCodeMinus2 = 109; // Opera and Firefox
export const keyCodeNumLock = 144;
export const keyCodeNumPad0 = 96;
export const keyCodeNumPad1 = 97;
export const keyCodeNumPad2 = 98;
export const keyCodeNumPad3 = 99;
export const keyCodeNumPad4 = 100;
export const keyCodeNumPad5 = 101;
export const keyCodeNumPad6 = 102;
export const keyCodeNumPad7 = 103;
export const keyCodeNumPad8 = 104;
export const keyCodeNumPad9 = 105;
export const keyCodeNumPadDivide = 111;
export const keyCodeNumPadDot = 110;
export const keyCodeNumPadMinus = 109;
export const keyCodeNumPadMultiply = 106;
export const keyCodeNumPadPlus = 107;
export const keyCodeOpenBracket = 219;
export const keyCodePageDown = 34;
export const keyCodePageUp = 33;
export const keyCodePeriod = 190;
export const keyCodePrint = 44;
export const keyCodeQuote = 222;
export const keyCodeScrollLock = 145;
export const keyCodeShift = 16;
export const keyCodeSpace = 32;
export const keyCodeTab = 9;
export const keyCodeTilde = 192;
export const keyCodeWindowsLeft = 91;
export const keyCodeWindowsOpera = 219; // Opera
export const keyCodeWindowsRight = 92;
